/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SipStartResponse } from '../models';
import type { VcsSipJoinRequest } from '../models';
import type { VcsSipStartRequest } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class VcsSipControllerService {
    public static start(
        requestBody: VcsSipStartRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<SipStartResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/sip/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static join(requestBody: VcsSipJoinRequest, options?: ApiRequestOptions): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/sip/join',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinAuthorized(
        requestBody: VcsSipJoinRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/sip/join-authorized',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
